import { CheckCircle2, Loader2, Trash2, XCircle } from "lucide-react";
import { money, when } from "@/lib/rides";
import { Button } from "@/components/ui/button";

const STATUS = {
  ready: { label: "Ready", tone: "text-muted-foreground" },
  creating: { label: "Creating…", tone: "text-neon-cyan" },
  created: { label: "Created", tone: "text-neon-lime" },
  failed: { label: "Needs attention", tone: "text-destructive" },
};

function Item({ item, i, onRemove, onRetry }) {
  const s = STATUS[item.status];
  return (
    <div className="space-y-1 border-t border-white/5 py-2 text-sm first:border-t-0" data-testid={`booking-list-item-${i}`}>
      <div className="flex items-start gap-2">
        <span className="font-display font-bold text-primary">{i + 1}</span>
        <span className="min-w-0 flex-1">
          <span className="block truncate font-semibold">{item.route}</span>
          <span className="block text-xs text-muted-foreground">{item.when ? when(item.when) : "As soon as possible"} · {item.type} · {item.rides} ride{item.rides > 1 ? "s" : ""} · {money(item.total)}</span>
        </span>
        <span className={`flex items-center gap-1 text-xs font-semibold ${s.tone}`} data-testid={`booking-list-status-${i}`}>
          {item.status === "creating" && <Loader2 className="h-3 w-3 animate-spin" />}{item.status === "created" && <CheckCircle2 className="h-3 w-3" />}
          {item.status === "failed" && <XCircle className="h-3 w-3" />}{s.label}
        </span>
        {["ready", "failed"].includes(item.status) && (
          <button type="button" onClick={() => onRemove(item.key)} data-testid={`booking-list-remove-${i}`}><Trash2 className="h-4 w-4 text-destructive" /></button>
        )}
      </div>
      {item.error && <p className="text-xs text-destructive">{item.error}</p>}
      {item.status === "failed" && item.canOverride && <Button size="sm" variant="outline" onClick={() => onRetry(item.key)} data-testid={`booking-list-override-${i}`}>Create anyway (override)</Button>}
    </div>
  );
}

export function BookingList({ items, onRemove, onRetry, onSubmit, busy }) {
  if (!items.length) return null;
  const open = items.filter((x) => x.status !== "created");
  const rides = open.reduce((a, x) => a + x.rides, 0);
  return (
    <div className="rounded-2xl border border-primary/40 bg-card p-4" data-testid="booking-list">
      <p className="mb-2 flex justify-between text-xs font-bold uppercase tracking-[0.14em] text-muted-foreground">
        <span>Booking list</span><span data-testid="booking-list-count">{items.length} booking{items.length > 1 ? "s" : ""} · {items.reduce((a, x) => a + x.rides, 0)} rides</span>
      </p>
      {items.map((x, i) => <Item key={x.key} item={x} i={i} onRemove={onRemove} onRetry={onRetry} />)}
      {!!open.length && (
        <Button className="mt-3 h-11 w-full rounded-full" disabled={busy} onClick={onSubmit} data-testid="booking-list-submit">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : `Create ${rides} ride${rides > 1 ? "s" : ""}`}
        </Button>
      )}
    </div>
  );
}
